import { render, staticRenderFns } from "./TranslateBtn.vue?vue&type=template&id=d9fee594&scoped=true&"
import script from "./TranslateBtn.vue?vue&type=script&lang=js&"
export * from "./TranslateBtn.vue?vue&type=script&lang=js&"
import style0 from "./TranslateBtn.vue?vue&type=style&index=0&id=d9fee594&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fee594",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/tmp/build/tooltranslate-ui/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
